import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { RequestDetailEvaluator } from '../shared/request-detail-evaluator.model';
import { SubjectEvaluateSelectedComponent } from '../subject-evaluate-selected/subject-evaluate-selected.component';
import { SubjectSelected } from '../shared/subject-selected.model';
import { DefermentCriteriaComponent } from '../deferment-criteria/deferment-criteria.component';
import { SavedEvaluation } from '../shared/saved-evaluation.model';
import { Criteria } from '../shared/criteria.model';
import { Matter } from '../../requets/shared/matter.model';
import { AssesmentsService } from '../shared/assesments.service';

@Component({
  selector: 'app-saved-evaluation',
  templateUrl: './saved-evaluation.component.html',
  styleUrls: ['./saved-evaluation.component.scss']
})
export class SavedEvaluationComponent implements OnInit {

  selection: String = '1';
  request: RequestReponse;
  requestDetail: RequestDetailEvaluator[];
  subjectsSelect: SubjectSelected[];
  messageError: String = '';
  enableSucces = false;
  enabledSpinner = false;
  @ViewChild(DefermentCriteriaComponent) defermentCriteriaComponent: DefermentCriteriaComponent;

  constructor(private location: Location,
              private router: Router,
              private assessmentsService: AssesmentsService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(
      (params) => {
        const param = JSON.parse(params['param']);
        console.log(param);
        this.request = param.request;
        this.requestDetail = param.subjects;
        this.subjectsSelect = param.subjectSelected;
      }
    );
  }
  back() {
    // this.router.navigate(['evaluaciones']);
    this.router.navigate(['evaluaciones/evaluar'], { queryParams: { request : localStorage.getItem('request') } });
    // this.location.back();
  }
  close() {
    this.location.back();
  }

  sendEvaluation() {
    const savedEvaluation = new SavedEvaluation();
    savedEvaluation.consecutivos = this.requestDetail.map(
      (subject: RequestDetailEvaluator ) => {
          subject.programa.codigo = this.request.programa.codigo;
          subject.programa.nombre = this.request.programa.nombre;
          subject.programa.version = this.request.programa.version;
          return subject;
      }
    );
    savedEvaluation.materiasReconocer =  this.subjectsSelect.map(
      (subject: SubjectSelected) => {
          subject.periodo = subject.periodo.replace('-', '');
          return subject;
      }
    );
    if (this.selection === '2') {
      if (this.defermentCriteriaComponent.prerequiment.subjects.length === 0 &&
          this.defermentCriteriaComponent.corequiment.subjects.length === 0 &&
          this.defermentCriteriaComponent.credits === 0) {
            this.messageError = 'Debe seleccionar algún criterio de aplazamiento';
            this.enableSucces = false;
      } else {
        const criteria = new Criteria();
        /*if (this.defermentCriteriaComponent.credits) {
          criteria.creditos = this.defermentCriteriaComponent.credits;
          this.messageError = '';
        } else {
          this.messageError = 'El número de créditos es requerido';
            this.enableSucces = false;
        }*/

        criteria.creditos = this.defermentCriteriaComponent.credits;
        this.messageError = '';

        const prerequiriment: String[] = this.defermentCriteriaComponent.prerequiment.subjects.map(
          (subject: Matter) => {
            return subject.codigo + '';
          }
        );
        const materias = new Object();
        materias['P'] = prerequiriment;
        const corequiriment: String[] = this.defermentCriteriaComponent.corequiment.subjects.map(
          (subject: Matter) => {
            return subject.codigo + '';
          }
        );
        materias['C'] = corequiriment;
        criteria.materias = materias;
        savedEvaluation.criterios = criteria;
      }
    }
    if (this.messageError === '') {
    this.enabledSpinner = true;
    this.messageError = '';
     this.assessmentsService.savedEvaluation(savedEvaluation).subscribe(
       (result) => {
        this.enabledSpinner = false;
        if (result.data) {
          const data = result.data as String;
          if (data.trim().length > 0) {
              this.messageError = data;
              this.enableSucces = false;
          } else {

            this.enableSucces = true;
          }
        }
      }
     );
    }
  }

  validateSend() {
      let validate = false;
      if (this.selection === '2') {
        if (this.defermentCriteriaComponent) {
          if (!this.defermentCriteriaComponent.credits &&
              this.defermentCriteriaComponent.corequiment.subjects.length === 0 &&
              this.defermentCriteriaComponent.prerequiment.subjects.length === 0 ) {
            validate = true;
          }
        } else {
          validate = true;
        }
      }
      return validate;
  }

}
